import React, { Component } from 'react';
import { Layout} from 'antd';
import Header from './HeaderLayout';
import SiderLayout from './SiderLayout';
import {connect} from 'react-redux'
import RutasAutenticadas from '../routes/RutasAutenticadas';
import { actionGetUsuario } from '../../store/acciones/accionesUsuario';
const { Content, Sider } = Layout;

class Dashboard extends Component {
    constructor(props) {
        super(props)
        
            this.state = {
                collapsed: false,
                MargenIzq: null,
                MarginTop: null
            };
        
    }

    toggle = () => {
        this.setState({
          collapsed: !this.state.collapsed,
        });
      }

    componentDidMount(){
        this.props.getUser()
    }

    render() {
        const{usuario}=this.props
        return (
            <Layout> 
                <Sider style={{
                overflow: 'auto', height: '100vh', position: 'fixed', textAlign: 'center', background:"#3261fb"
                    }}
                    width="250"
                    breakpoint="xs"
                    collapsedWidth="80"
                    onBreakpoint={(broken) => { 
                                if(broken){
                                    this.setState({
                                        MargenIzq:80,
                                        MarginTop:80
                                    })
                                }
                                else{
                                    this.setState({
                                        MargenIzq:250,
                                        MarginTop:60
                                    })
                                }
                        }}
                    onCollapse={(collapsed, type) => { console.log(collapsed, type); }}
                >
                    <SiderLayout path={this.props.match}  usuario={usuario}/>
                </Sider>
                <Layout style={{marginLeft:this.state.MargenIzq}}>
                    <Header logout={this.props.logout} usuario={usuario}  />
                    <Content style={{marginTop:this.state.MarginTop}}>
                        <div style={{ background: '#fff',  minHeight: '100vh', boxSizing:"border-box", padding:"20px" }}>
                            <RutasAutenticadas path={this.props.match} usuario={usuario}/>
                        </div>
                    </Content>
                </Layout>
            </Layout>
        );
    }
}

const mapStateToProps = (state, ) => {
    return {
        usuario: state.reducerUsuario.usuario
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        getUser:()=>{
            dispatch(actionGetUsuario())
         }
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(Dashboard)